import React from 'react';
import { ArrowRightIcon, FileTextIcon } from 'lucide-react';
export function Portfolio() {
  const portfolioItems = [{
    title: 'SEO Article Sample',
    description: 'An in-depth article optimized for search engines with strategic keyword placement.',
    link: 'https://docs.google.com/document/d/1cbhBGzKqKpvbAYtri77GuZBUjNY6Lfn_fNfiwc4ukRk/edit?usp=sharing'
  }, {
    title: 'Blog Post Sample',
    description: 'An engaging blog post designed to inform and entertain the target audience.',
    link: 'https://docs.google.com/document/d/1pDLek1K47LuWU6H8qgOMbQ4x4DhOsVNzBH0Yp_UGyAM/edit?usp=sharing'
  }, {
    title: 'Website Copy Sample',
    description: 'Persuasive website copy created to convert visitors into customers.',
    link: 'https://docs.google.com/document/d/1tMzetv7yVud94MHBn6VKZ-Fhmvd4A5iU6QX5CBvi-Yg/edit?usp=sharing'
  }];
  return <section id="portfolio" className="py-20 px-4 bg-white" data-id="element-129">
      <div className="max-w-6xl mx-auto" data-id="element-130">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-16" data-id="element-131">
          Portfolio
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-132">
          {portfolioItems.map((item, index) => <div key={index} className="bg-blue-50 p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-blue-100" data-id="element-133">
              <div className="mb-6 text-blue-600" data-id="element-134">
                <FileTextIcon className="h-12 w-12" data-id="element-135" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-136">
                {item.title}
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-137">{item.description}</p>
              <a href={item.link} target="_blank" rel="noopener noreferrer" className="text-blue-600 font-medium hover:text-blue-800 inline-flex items-center" data-id="element-138">
                Read Sample
                <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-139" />
              </a>
            </div>)}
        </div>
        <div className="text-center" data-id="element-140">
          <a href="#contact" className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 transition-colors shadow-md hover:shadow-lg" data-id="element-141">
            Request Full Portfolio
            <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-142" />
          </a>
        </div>
      </div>
    </section>;
}